module.exports = __webpack_public_path__ + "static/media/country_md.860fd9a4.webp";